<template>
  <div class="tabs_content" id="tab-2" >
    <section>
      <div class="status">
        <h2 v-translate>Jazykové předvolby</h2>
        <a v-if="isEditable && isAddLanguagePresetAllowed" class="add add_expand" :class="{ open: addLanguageOpened && isAddLanguagePresetAllowed }" @click.stop.prevent="_toggleAddLanguagePresets" :title="$gettext('Přidat jazykovou předvolbu')" v-translate>Přidat jazykovou předvolbu</a>
      </div>

      <div class="filter expand_content" :class="{ open: addLanguageOpened && isAddLanguagePresetAllowed }">
        <div class="field_left">
          <select-box
              id="contentLanguagePresets"
              v-model="selectedLanguagePreset"
              :options="availableLanguagesKeysOptions">
            <translate class="translate">Jazyk</translate>
          </select-box>
        </div>

        <div class="field_right">
          <p class="field">
            <input class="btn" type="submit" :value="'Přidat' | translate" @click.stop.prevent="onAddLanguagePreset">
          </p>
        </div>
      </div>


      <div>
        <table class="vypis vypis_detail" >
          <tr v-if="noLanguagePresets">
            <td v-translate>Nastavení se neuplatňuje.</td>
          </tr>

          <tr v-else v-for="(languageValues, languageKey) in languagePresets.values" :key="'language_preset_key_' + languageKey">
            <td>
              <LanguagePresets
                  :languagePresetsObject="languagePresets"
                  :languageValues="languageValues"
                  :languageKey="languageKey"
                  :is-editable="isEditable"
                  :allowedLanguages="allowedLanguages"
                  @removeLanguagePreset="onRemoveLanguagePreset"
                  @removeLanguagePresetValue="onRemoveLanguagePresetValue"
                  @addLanguagePresetValue="onAddLanguagePresetValue"
                  @sortLanguagePreset="onSortLanguagePreset"
              />
            </td>
          </tr>
        </table>
      </div>

    </section>
  </div>
</template>

<script>


import LanguagePresets from "./LanguagePresets";
import languages from "../../../mixins/languages";

export default {
  name: "ContentLanguagePresets",
  props: {
    entity: Object,
    isEditable: Boolean,
  },
  data() {
    return {
      addLanguageOpened: false,
      selectedLanguagePreset: null,
      allowedLanguages: [],
      languagePresets: {
        values : [],
        editable: true,
        default : null
      },
    };
  },
  created(LanguageListService) {
    this.languageListService = LanguageListService;

    this.languageListService.getEntities().then((data) => {
      this.allowedLanguages = data;
    });

    if (this.entity.platform.content_language_preset) {
      this.languagePresets = this.entity.platform.content_language_preset;
    }
  },
  mixins: [languages],
  components: { LanguagePresets },
  methods: {
    onAddLanguagePreset() {
      if (!this.entity.platform.content_language_preset) {
        this.entity.platform.content_language_preset = this.languagePresets;
      }
      this.languagePresets['values'] = {...this.entity.platform.content_language_preset['values'], [this.selectedLanguagePreset] : [] };
      this.entity["platform"]["content_language_preset"] = this.languagePresets;
      this.entity["platform"] = {...this.entity["platform"]};
    },
    onAddLanguagePresetValue(languageKey, languageValue) {
      this.entity.platform.content_language_preset.values[languageKey] = [...this.entity.platform.content_language_preset.values[languageKey], languageValue];
      this.languagePresets = {...this.entity.platform.content_language_preset};
    },
    onRemoveLanguagePreset(languagePresetKey) {
      delete this.entity.platform.content_language_preset.values[languagePresetKey];
      this.entity.platform.content_language_preset.values = {...this.entity.platform.content_language_preset.values};
      this.languagePresets = {...this.entity.platform.content_language_preset};

      if (Object.keys(this.entity.platform.content_language_preset.values).length === 0) {
        delete this.entity.platform['content_language_preset'];
        this.entity.platform = {...this.entity.platform};
      }
    },
    onRemoveLanguagePresetValue(languageKey, languageValue) {
      this.entity.platform.content_language_preset.values[languageKey] = this.entity.platform.content_language_preset.values[languageKey].filter((value) => value != languageValue);
      this.languagePresets = {...this.entity.platform.content_language_preset};
    },
    _toggleAddLanguagePresets() {
      this.addLanguageOpened = !this.addLanguageOpened;
    },
    onSortLanguagePreset(languageKey, newLanguagePresetValuesSort) {
      this.entity.platform.content_language_preset.values[languageKey] = newLanguagePresetValuesSort;
      this.languagePresets = {...this.entity.platform.content_language_preset};
    },
  },
  computed: {
    languagePresetsKeys() {
      return this.languagePresets ? Object.keys(this.languagePresets.values) : [];
    },
    noLanguagePresets() {
      let languagePresetsNotDefined = true;

      try {
        languagePresetsNotDefined = Object.keys(this.languagePresets.values).length === 0;
      } catch (e) {
      }

      return languagePresetsNotDefined;
    },
    availableLanguagesKeys() {
      return this.allowedLanguages ? this.allowedLanguages.filter((value) => {
        return !this.languagePresetsKeys.includes(value);
      }) : [];
    },
    availableLanguagesKeysOptions() {
      const values = [];

      this.availableLanguagesKeys.forEach((value) => {
        values.push({
          id: value,
          text: this.getLanguageNameByCode(value),
        });
      });

      if (this.availableLanguagesKeys.length > 0 && !this.availableLanguagesKeys.includes(this.selectedLanguagePreset)) {
        this.selectedLanguagePreset = this.availableLanguagesKeys[0];
      }

      return values;
    },
    hasSelectableAllowedLanguages() {
      return !!this.allowedLanguages;
    },
    isAddLanguagePresetAllowed() {
      return !this.hasSelectableAllowedLanguages || (this.hasSelectableAllowedLanguages && this.availableLanguagesKeys.length > 0);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/deviceConfigs/forms/ContentLanguagePresets.vue